import { render, staticRenderFns } from "./CouponPreview.vue?vue&type=template&id=5b77b98c&scoped=true&"
import script from "./CouponPreview.vue?vue&type=script&lang=js&"
export * from "./CouponPreview.vue?vue&type=script&lang=js&"
import style0 from "./CouponPreview.vue?vue&type=style&index=0&id=5b77b98c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b77b98c",
  null
  
)

export default component.exports